import { Typography } from "@sphtech/dmg-design-system";
import { StoryData } from "@src/app/types/ServerCustomContext";
import { getSponsorName, isSponsoredStory } from "@src/app/utils/sponsored";
import { ReactNode } from "react";

const { Disclaimer } = Typography;

type SponsorshipProps = {
  sponsorship: StoryData["sponsorship"];
  typeName: string;
};

export default function Sponsorship({
  sponsorship,
  typeName,
}: SponsorshipProps): ReactNode {
  if (isSponsoredStory(sponsorship, typeName)) {
    const text = getSponsorName(sponsorship);
    return text && <Disclaimer big>{text}</Disclaimer>;
  }
}
